var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#ffffff",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 298.666667c117.76 0 213.333333 95.573333 213.333333 213.333333 0 27.52-5.546667 53.76-15.146666 77.866667l124.8 124.8c64.426667-53.76 115.2-123.306667 146.56-202.666667-74.026667-187.306667-256-320-469.546667-320-59.733333 0-116.906667 10.666667-170.026667 29.866667l92.16 91.946666c24.106667-9.386667 50.346667-15.146667 77.866667-15.146666zM85.333333 182.4l97.28 97.28 19.413334 19.413333C131.626667 354.133333 75.946667 427.306667 42.666667 512c73.813333 187.306667 256 320 469.333333 320 66.133333 0 129.28-12.8 187.093333-36.053333l18.133334 18.133333L841.6 938.666667 896 884.48 139.733333 128 85.333333 182.4zM321.28 418.133333l65.92 65.92c-1.92 9.173333-3.2 18.346667-3.2 27.946667 0 70.613333 57.386667 128 128 128 9.6 0 18.773333-1.28 27.733333-3.2l65.92 65.92C577.28 716.8 545.706667 725.333333 512 725.333333c-117.76 0-213.333333-95.573333-213.333333-213.333333 0-33.706667 8.533333-65.28 22.613333-93.866667z m183.68-33.493333l134.4 134.4L640 512c0-70.613333-57.386667-128-128-128l-7.04 0.64z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibilityOff.15e5f264fc70b4c8038381716521b47a.svg";
export { ForwardRef as ReactComponent };